import { processingResultSelectors } from '@processingResults/redux';
import type { TexturedMesh } from '@processingResults/types';
import { useSelector } from 'react-redux';

export const useTexturedMesh = (processingResultId: string): TexturedMesh | undefined => {
  const processingResult = useSelector(processingResultSelectors.selectById(processingResultId));
  return processingResult?.texturedMeshes?.[0];
};
